import { render, staticRenderFns } from "./taskDeliverModify.vue?vue&type=template&id=13e9f6c4&scoped=true"
import script from "./taskDeliverModify.vue?vue&type=script&lang=js"
export * from "./taskDeliverModify.vue?vue&type=script&lang=js"
import style0 from "./taskDeliverModify.vue?vue&type=style&index=0&id=13e9f6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e9f6c4",
  null
  
)

export default component.exports